import React, { useEffect, useState } from "react";
import { CommonUtilities } from "../../commonUtils";
import Pagination from 'components/Common/newPagination';
import Header from "../Header/header";
import MainWizard from "../wizard/MainWizard";
import gridTemplateService from "./gridTemplateService";
import ContractSummary from "../Contracts/ContractSummary";
import CommonSearch from "../commonSearch/CommonSearch";
import ExportOption from "../Common/exportOption";
import ContractNotes from "components/Contracts/ContractNotes";
import StatementHistory from "components/Generation/statementHistory";

export default function ContractGrid(param: any) {
    let [contactList, initContactList] = useState<any>([]);
    let [totalRows, setTotalRows] = useState(0);
    let [gridHeader, initGridHeader] = useState<any>([]);
    let [gridVisibility, initGridVisibility] = useState<any>([]);
    let [GridOriginal, initGridOriginal] = useState<any>([]);
    let [GridOrdering, initGridOrdering] = useState<any>([]);
    let [openMainWizard, setopenMainWizard] = useState(false);
    let [openDealsManager, setopenDealsManager] = useState(false);
    let [selectedMainWizard, setselectedWizard] = useState<any>([]);
    let [statementHistoryOpen, setStatementHistoryOpen] = useState(false);
    let [selectContract, setSelectedContracts] = useState<any>([]);
    let [conSummaryStatus, setConSummaryStatus] = useState(false);
    let [noteOpen, setnoteOpen] = useState(false)
    let [exportOption, setExportOption] = useState("")
    let [activeTab, setactiveTab] = useState("Status")


    var dataLink = "pageSize=10&pageNumber=1";
    var search_For = "";

    useEffect(() => {
        getContacts();
        //search();
    }, []);

    let Data: any = {
        pageSize: 10,
        pageNumber: 1,
        export: 0,
        searchFor: '',
        sortBy: '',
        sortOrder: '',
        additionalInfo: "Status"
    }

    const handleNameOnChange = (n: any) => {
        Data.pageNumber = n.pageNumber;
        Data.pageSize = n.pageSize;
        dataLink = 'pageSize=' + Data.pageSize + '&pageNumber=' + Data.pageNumber;
        getContacts()
    }

    const getContacts = () => {

        for (var i = 0; i < GridOrdering.length; i++) {
            if (GridOrdering[i] === 1) {
                console.log(GridOrdering[i])
                console.log(GridOriginal[i])
                Data.sortBy = GridOriginal[i];
                Data.sortOrder = "ASC";
            }

            if (GridOrdering[i] === 2) {
                console.log(GridOrdering[i])
                console.log(GridOriginal[i])
                Data.sortBy = GridOriginal[i];
                Data.sortOrder = "DESC";
            }
        }

        gridTemplateService.ContractListing(Data).then((res: any) => {

            if (res) {
                CommonUtilities.relativeDataRemapping(res?.data, res.headers.original);
                initContactList(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));
                setTotalRows(res.totalRows)

                console.log(CommonUtilities.relativeDataRemapping(res.data, res.headers.original))
                initGridHeader(reMap(res.headers.display));
                initGridVisibility(reMap(res.headers.visible));
                initGridOriginal(reMap(res.headers.original));

                const exists = GridOrdering.includes(1);
                if (GridOrdering.includes(1) || GridOrdering.includes(2)) {
                    // do something
                    initGridOrdering(GridOrdering)
                } else {

                    initGridOrdering(reMapOrdering(res.headers.original))
                }

                console.log(reMap(res.headers.display))

            }

        })
    }

    const reMap = (mapReturn: any) => {
        var tempmapReturn: any[] = [];
        Object.entries(mapReturn).forEach(([key, value]) => { tempmapReturn.push(value) });
        return tempmapReturn;
    }

    const reMapOrdering = (mapReturn: any) => {
        //0 order by not selected
        // 1 order by 

        var tempmapReturn: any[] = [];
        Object.entries(mapReturn).forEach(([key, value]) => { tempmapReturn.push(0) });

        console.log(tempmapReturn)
        return tempmapReturn;
    }

    const reMapOrderingSet = (index: any) => {
        //0 order by not selected
        // 1 order by 
        for (var i = 0; i < GridOrdering.length; i++) {
            if (i != index) {
                GridOrdering[i] = 0;
            }
        }

        if (GridOrdering[index] == 0) {
            GridOrdering[index] = 1
        } else if (GridOrdering[index] == 1) {
            GridOrdering[index] = 2
        } else if (GridOrdering[index] == 2) {
            GridOrdering[index] = 0
        }

        console.log(GridOrdering)
        initGridOrdering((existingValues: any) => ([...GridOrdering]));

        getContacts();
    }

    const search = (e: any) => {
        Data.searchFor = e;
        getContacts()
    }

    const MainWizardClose = () => {
        setopenMainWizard(false)
    }

    const exportContact = (type: any) => {
        gridTemplateService.exportContact({ export: true, exportType: type });
    }

    const savecontactsGridResult = (filterName: any, status: any) => {
        console.log(filterName)
        console.log(status)
        gridTemplateService.savecontactsGridResult({ filterName: filterName, status: status === 0 ? 1 : 0, type: "contactsGridResult" }).then((res) => { getContacts(); })
    }

    const onSaveUpdate = (e: any) => {
        console.log(e);
        setselectedWizard(e)
    }

    const closeDealsManager = () => {
        setopenDealsManager(false)
    }

    const SearchForHandle = (e: any, sts: any) => {
        console.log(e)
        console.log(sts)

        if ((sts === true)) {
            Data.searchFor = e?.searchFor;
            getContacts();
            console.log(Data)

        }
    }

    const tabChange = (e: any) => {
        activeTab = e;
        setactiveTab(activeTab)
        Data.additionalInfo = e;
        getContacts();
    }

    const changeExportContract = (e: any) => {
        exportOption = e;
        setExportOption(exportOption);
    }

    const onChange = (e: any) => {
        console.log(e)

        if (e.optSts === 1) {
            var paylaod = { ...e, ...{ additionalInfo: activeTab, exportType: e.type } }
            console.log(paylaod)
            gridTemplateService.ExportContractDetails(paylaod)
        }

        exportOption = '';
        setExportOption(exportOption)
    }

    const openContractSummary = (contract: any) => {
        console.log(contract)
        selectContract = contract
        setSelectedContracts(selectContract);
        conSummaryStatus = true
        setConSummaryStatus(conSummaryStatus)
        console.log(conSummaryStatus)
    }

    const onchangeContract = (e: any) => {
        console.log(e)

        conSummaryStatus = false
        setConSummaryStatus(conSummaryStatus)
        //setSelectedContracts(e)
    }

    const onChangContractNote = (e: any) => {
        noteOpen = false;
        setnoteOpen(noteOpen)
    }

    const closeStatementHistory = () => { setStatementHistoryOpen(false); }

    return (
        <div className="ws-12 landingContainer allowHscroll allowVscroll">

            {param?.type != "NonLanding" && <div className='ws-12'>
                <Header Title={"Contracts"} />
            </div>}

            <div className='ws-12 mtl pLarge '>
                <CommonSearch SearchForHandle={SearchForHandle} type="contractGrid" title="contractGrid" width="ws-12 pull-left" />
            </div>

            <div className="ws-12 landingPage pm">

                <div className="ws-12">
                    <div className="box-header">
                        <h2 className="pull-left capitalize">Search Results: {totalRows}</h2>

                        <div className="pull-right">
                            <div className="verticalMediumWide hover-box pull-right">
                                <ul className="hover-block textboxDropdownList box pm rightReset">

                                    {gridHeader?.map((values: any, index: any) => {

                                        if (values !== 'totalRow' && gridVisibility[index] !== 2) {
                                            return (
                                                <li className="hover-box text-left ws-6 pb">
                                                    <input type="checkbox" checked={gridVisibility[index]} onClick={() => savecontactsGridResult(GridOriginal[index], gridVisibility[index])} /> {values}
                                                </li>
                                            )
                                        }
                                    })}

                                </ul>

                                <button className="icon-btn info height40 width40">
                                    <i className="icon-LPurple-Setting "></i>
                                </button>
                            </div>
                        </div>

                        <button type="button" className="icon-btn edit pull-right height40 width150" ng-click="ExportList();"><i className="icon-download1"></i>Export Listing</button>

                        <button type="button" className="icon-btn edit pull-right width150 height40" ng-click="ROYContractWizard();"><i className="icon-file-add"></i> Add contract</button>

                        <div className="verticalMediumWide hover-box pull-right bgTransparent">
                            <button type="button" className="hover-box icon-btn edit height40 width150" ><i className="icon-download1"></i> Export</button>

                            <ul className="hover-block textboxDropdownList noShadow rightReset mtxl ptl borderNone noOutline bgTransparent">
                                <div className="ws-6 pull-right box pm">

                                    <li className="pt ws-10 pull-right" onClick={() => changeExportContract("ContractStatus")}>Contract Status</li>
                                    <li className="pt ws-10 pull-right" onClick={() => changeExportContract("Regions")} >Regions</li>
                                    <li className="pt ws-10 pull-right" onClick={() => changeExportContract("RatesBasis")} >Rates/Basis</li>
                                    <li className="pt ws-10 pull-right" onClick={() => changeExportContract("Reserves")} >Reserves</li>
                                    <li className="pt ws-10 pull-right" onClick={() => changeExportContract("Adjustments")}>Adjustments</li>
                                    <li className="pt ws-10 pull-right" onClick={() => changeExportContract("ReducingRoyalties")}>Reducing Royalties</li>
                                </div>
                            </ul>

                        </div>

                    </div>

                    <div className="ws-12 allowHscroll pt pb mb">

                        <div className="pull-left mb ws-12">
                            <ul className="nav nav-tabs p0 m0 hide">
                                <li className={activeTab === 'Status' ? "m0 mr active" : "m0 mr"} onClick={() => tabChange("Status")}>   Status  </li>
                                <li className={activeTab === 'Approval' ? "m0 mr active" : "m0 mr"} onClick={() => tabChange("Approval")}> Approval  </li>
                                <li className={activeTab === 'Deductions' ? "m0 mr active" : "m0 mr"} onClick={() => tabChange("Deductions")}>  Deductions  </li>
                                <li className={activeTab === 'Balances' ? "m0 mr active" : "m0 mr"} onClick={() => tabChange("Balances")}>  Balances </li>
                                <li className={activeTab === 'Details' ? "m0 mr active" : "m0 mr"} onClick={() => tabChange("Details")}>  Details </li>
                            </ul>

                        </div>

                        {totalRows > 0 && gridHeader && <table className="newTable allowHscroll allowVscroll ws-12">
                            <thead>
                                <tr>
                                    {gridHeader?.map((values: any, index: any) => {
                                        if (values !== 'totalRow' && gridVisibility[index] !== 0) {
                                            return (<>
                                                <th className="forceSingleLine ">

                                                    <div className="ws-12">
                                                        <span className=" w-70 text-left pt">{values} </span>
                                                        <a className="pull-right" onClick={() => reMapOrderingSet(index)}>
                                                            {GridOrdering[index] === 0 && <i className="icon-sort text-m mt"></i>}
                                                            {GridOrdering[index] === 2 && <i className="icon-caret-down text-m mt"></i>}
                                                            {GridOrdering[index] === 1 && <i className="icon-caret-up text-m mt"></i>}
                                                        </a>

                                                    </div>

                                                </th>
                                                {/*  {GridOrdering[index] === 0 && <span style={{ fontSize: "10px" }}>↕</span>}
                                                        {GridOrdering[index] === 1 && <span>↑</span>}
                                                        {GridOrdering[index] === 2 && <span>↓</span>}
                                                        <span className="hide"> {GridOrdering[index]} </span> */}
                                            </>)
                                        }
                                    })}

                                    <th style={{ minWidth: "150px" }}>Operation</th>
                                </tr>
                            </thead>

                            <tbody>

                                {contactList?.map((Datavalues: any, index: any) => {
                                    return (
                                        <tr>
                                            {GridOriginal?.map((values: any, index: any) => {
                                                if (values !== 'totalRow' && gridVisibility[index] === 1) {
                                                    return (<>
                                                        <td >
                                                            <a className={Datavalues[values] && values === "contractStatusName" ? "btn  text-center m0 width-auto inline pull-none" : "hide"}
                                                                style={{
                                                                    background: CommonUtilities.lookUpTypeList('contractStatusName', Datavalues[values], 'bgColor'),
                                                                    color: CommonUtilities.lookUpTypeList('contractStatusName', Datavalues[values], 'fontColor')
                                                                }} >
                                                                {Datavalues[values]}
                                                            </a>

                                                            <a className={Datavalues[values] && values === "accountStatusName" ? "btn text-center m0 full-width inline pull-none forceSingleLine" : "hide"}
                                                                style={{
                                                                    background: CommonUtilities.lookUpTypeList('accountStatusName', Datavalues[values], 'bgColor'),
                                                                    color: CommonUtilities.lookUpTypeList('accountStatusName', Datavalues[values], 'fontColor')
                                                                }} >
                                                                {Datavalues[values]}
                                                            </a>

                                                            <a className={Datavalues[values] && values === "accountStatusExtName" ? "btn ws-12 m0 text-center full-width inline pull-none forceSingleLine" : "hide"}
                                                                style={{
                                                                    background: CommonUtilities.lookUpTypeList('accountStatusExtName', Datavalues[values], 'bgColor'),
                                                                    color: CommonUtilities.lookUpTypeList('accountStatusExtName', Datavalues[values], 'fontColor')
                                                                }} >
                                                                {Datavalues[values]}
                                                            </a>

                                                            <a className={Datavalues[values] && values === "payeeStatusName" ? "btn ws-12 text-center m0 full-width inline pull-none forceSingleLine" : "hide"}
                                                                style={{
                                                                    background: CommonUtilities.lookUpTypeList('payeeStatusName', Datavalues[values], 'bgColor'),
                                                                    color: CommonUtilities.lookUpTypeList('payeeStatusName', Datavalues[values], 'fontColor')
                                                                }} >
                                                                {Datavalues[values]}
                                                            </a>

                                                            <a className={Datavalues[values] && values === "statementStatusName" ? "btn ws-12 text-center m0 full-width inline pull-none" : "hide"}
                                                                style={{
                                                                    background: CommonUtilities.lookUpTypeList('statementStatusName', Datavalues[values], 'bgColor'),
                                                                    color: CommonUtilities.lookUpTypeList('statementStatusName', Datavalues[values], 'fontColor')
                                                                }} >
                                                                {Datavalues[values]}
                                                            </a>

                                                            <span className={values !== "contractStatusName" && values !== "accountStatusName" && values !== "contractTitle" && values !== "contractRefNum" && values !== "statementStatusName" && values !== "accountStatusExtName" && values !== "payeeStatusName" ? "" : "hide"}>
                                                                <span className="greyDark">{Datavalues[values]} </span>
                                                            </span>

                                                            {values === "contractRefNum" && <>
                                                                <span className="greyDark" onClick={() => openContractSummary(Datavalues)}>{Datavalues[values]} </span>
                                                            </>}

                                                            {values === "contractTitle" && <div>
                                                                <span className="greyDark" onClick={() => openContractSummary(Datavalues)}>{Datavalues[values]} </span>
                                                            </div>}
                                                        </td> </>)
                                                }
                                            })}

                                            <td style={{ width: "12% !important" }}>
                                                <button className="icon-btn info" type="button" onClick={() => { setStatementHistoryOpen(true); setselectedWizard(Datavalues); }}><i className="icon-history"></i></button>
                                                <button className="icon-btn info" type="button" onClick={() => { setnoteOpen(true); setselectedWizard(Datavalues); }}><i className="icon-note"></i></button>
                                                <button className="icon-btn edit" type="button" onClick={() => { setopenMainWizard(true); setselectedWizard(Datavalues); }}><i className="icon-pen"></i></button>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>

                        </table>}

                    </div>
                    {(() => {
                        if (totalRows && totalRows > 10) {
                            return <Pagination onPageChange={handleNameOnChange} totalRow={totalRows} />;
                        }

                    })()}


                </div>
            </div>

            {(() => {
                if (openMainWizard) {
                    return <MainWizard openMainWizard={openMainWizard} MainWizardClose={MainWizardClose} type="Contract" code={selectedMainWizard} onSaveUpdate={onSaveUpdate} />
                }
                if (exportOption && exportOption.length > 0) {
                    return <ExportOption exportOption={exportOption} onChange={onChange} />
                }

                if (conSummaryStatus) {
                    return (<ContractSummary contractDetails={selectContract} from={"contract"} return="title" open={conSummaryStatus} onchangeContract={onchangeContract} />);
                }

                if (noteOpen) {
                    return <ContractNotes noteOpen={noteOpen} onChangContractNote={onChangContractNote} selectedMainWizard={selectedMainWizard} />
                }

                if (statementHistoryOpen) {
                    return <StatementHistory open={statementHistoryOpen} closeStatementHistory={closeStatementHistory} type="projectGeneration" statementHistoryDetail={selectedMainWizard} />
                }

            })()}
        </div>
    );
}